import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon, PackageIcon } from 'lucide-react';
interface CategoryCardProps {
  category: {
    id: string;
    name: string;
    icon: string;
    color: string;
    bgColor: string;
    textColor: string;
    productCount: number;
    subcategories: string[];
    image: string;
  };
}
export function CategoryCard({
  category
}: CategoryCardProps) {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  return <div className="bg-white rounded-2xl transition-all duration-300 overflow-hidden group cursor-pointer border border-gray-100 hover:border-gray-200" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onClick={() => navigate(`/category/${category.id}`)} data-id="element-5300" data-mp="bh9ny7tphr78">
      {/* Header with gradient and image */}
      <div className={`relative h-32 bg-gradient-to-r ${category.color} p-6`} data-id="element-5301" data-mp="3oot706gqgm55">
        {/* Background pattern */}
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="%23ffffff" fill-opacity="1" fill-rule="evenodd"%3E%3Ccircle cx="3" cy="3" r="3"/%3E%3Ccircle cx="13" cy="13" r="3"/%3E%3C/g%3E%3C/svg%3E")'
      }} data-id="element-5302" data-mp="3jqwjgm922mhb"></div>
        {/* Category image */}
        <div className="absolute right-4 top-4 w-20 h-20 opacity-20 group-hover:opacity-30 transition-opacity" data-id="element-5303" data-mp="6dbbfehzrqwl">
          <img src={category.image} alt={category.name} className="w-full h-full object-cover rounded-lg" data-id="element-5304" data-mp="b9ii59i7p6fl" />
        </div>
        {/* Icon and name */}
        <div className="relative z-10" data-id="element-5305" data-mp="1fi7ks45v8zh">
          <div className="text-4xl mb-2" data-id="element-5306" data-mp="2i1jaka979d14">{category.icon}</div>
          <h3 className="text-xl font-bold text-white" data-id="element-5307" data-mp="2i45k2ffni2lz">{category.name}</h3>
        </div>
      </div>
      {/* Content */}
      <div className="p-6" data-id="element-5308" data-mp="skxge3lob6fm">
        {/* Product count */}
        <div className="flex items-center gap-2 mb-4 text-gray-600" data-id="element-5309" data-mp="skdxajkaec00">
          <PackageIcon className="w-4 h-4" data-id="element-5310" data-mp="nmvp4ve3g0t2" />
          <span className="text-sm font-medium" data-id="element-5311" data-mp="nnxb3uwne7pk">
            {category.productCount}+ Products
          </span>
        </div>
        {/* Subcategories */}
        <div className="space-y-2 mb-4" data-id="element-5312" data-mp="duzr1kc0caou">
          {category.subcategories.slice(0, 5).map((sub, index) => <button key={index} onClick={e => {
          e.stopPropagation();
          navigate(`/category/${category.id}/${sub.toLowerCase().replace(/\s+/g, '-')}`);
        }} className="flex items-center justify-between w-full text-left py-2 px-3 rounded-lg hover:bg-gray-50 transition-colors group/item" data-id="element-5313" data-mp="9v7d0s3uhcc3" data-mpi={index}>
              <span className="text-sm text-gray-700 group-hover/item:text-[#1E2B55]" data-id="element-5314" data-mp="1u9hpjykzmqn6">
                {sub}
              </span>
              <ChevronRightIcon className="w-4 h-4 text-gray-400 group-hover/item:text-[#1E2B55] group-hover/item:translate-x-1 transition-all" data-id="element-5315" data-mp="1xs6x4axz6xjr" />
            </button>)}
        </div>
        {/* View All button */}
        <button onClick={e => {
        e.stopPropagation();
        navigate(`/category/${category.id}`);
      }} className={`w-full ${category.bgColor} ${category.textColor} font-medium py-3 rounded-lg hover:shadow-md transition-all flex items-center justify-center gap-2`} data-id="element-5316" data-mp="26k8q5o5ptbk0">
          View All
          <ChevronRightIcon className="w-4 h-4" data-id="element-5317" data-mp="1iv7rgsmoperx" />
        </button>
      </div>
    </div>;
}